let wasLastValuePositive = true;

export default (polaroidImage: HTMLElement) => {
    let value = Math.random() * 5;
    wasLastValuePositive = !wasLastValuePositive;
    if (wasLastValuePositive) {
        value *= -1;
    }
    polaroidImage.style.transform = "rotate(" + value + "deg)";
}